import { IEventLoggingComponentProps, withEventLogging } from '@AppModels/Logging';
import { EmailWorkloadViewModel, IEmailSendEstimate, IScheduledSend, ScheduleCriteria } from '@ViewModels';
import { css } from 'aphrodite';
import { inject } from 'mobx-react';
import moment from 'moment';
import * as React from 'react';
import { IModalContext, ModalChildComponentContextKey } from '../../../../../models';
import { IUserSessionComponentProps } from '../../../../../models/AppState';
import { ConfigureScheduledSend } from '../../../../components/email/ConfigureScheduledSend';
import { asModalComponent } from '../../../Modal';
import { styleSheet } from './styles';

interface IProps extends IUserSessionComponentProps, IEventLoggingComponentProps, IModalContext<IScheduledSend> {
	className?: string;
	estimatedEmailTotal?: number;
	emailWorkload?: EmailWorkloadViewModel;
	initialSchedule: IScheduledSend;
	numberOfEmailsToSend: number;
}

interface IState {
	selectedDate?: Date;
	sendEstimateForToday?: IEmailSendEstimate;
}

export class RescheduleSend extends React.PureComponent<IProps, IState> {
	constructor(props: IProps) {
		super(props);
		this.state = {
			selectedDate: props.initialSchedule ? new Date(props.initialSchedule.startDate) : new Date(),
		};
	}

	public render() {
		const { className, numberOfEmailsToSend, emailWorkload, initialSchedule } = this.props;
		const { selectedDate } = this.state;
		return (
			<div className={`${css(styleSheet.container)} reschedule-send ${className || ''}`}>
				<ConfigureScheduledSend
					emailWorkload={emailWorkload}
					initialSchedule={initialSchedule}
					numberOfEmailsToSend={numberOfEmailsToSend}
					onDone={this.onRescheduleButtonClicked}
					onSelectedDateChanged={this.onSelectedDateChanged}
					selectedDate={selectedDate}
					submitButtonText='Reschedule'
				/>
			</div>
		);
	}

	private onSelectedDateChanged = (selectedDate: Date) => {
		this.setState({
			selectedDate,
		});
	};

	private onRescheduleButtonClicked = (): Promise<any> => {
		const { parentModal, initialSchedule } = this.props;
		const { selectedDate } = this.state;
		if (!!parentModal && !!selectedDate) {
			const result: IScheduledSend = {
				...(initialSchedule || {}),
				criteria: ScheduleCriteria.StartAfter,
				startDate: moment.utc(selectedDate).toISOString(),
			};
			parentModal.onRequestClose(result, false);
		}

		return null;
	};
}

const RescheduleSendWithContext = inject(ModalChildComponentContextKey)(RescheduleSend);
export const RescheduleSendModal = withEventLogging(
	asModalComponent(RescheduleSendWithContext, {
		className: 'reschedule-send-modal',
		useDefaultHeader: true,
	}),
	'Rescheduler'
);
